import { map } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "../services/module.service";
import * as i2 from "@angular/router";
export class ModuleAvailableGuard {
    constructor(moduleService, router) {
        this.moduleService = moduleService;
        this.router = router;
    }
    canActivate(next, state) {
        // getting the identifier from routes
        const moduleIdentifier = next.data ? next.data.identifier : undefined;
        return this.moduleService.getModules().pipe(map((modules) => {
            // it means that is a public module
            if (!moduleIdentifier) {
                return true;
            }
            const moduleExists = modules.some((module) => module.identifier === moduleIdentifier);
            if (!moduleExists) {
                this.router.navigate(['/']); // Redirect to home or error page
                return false;
            }
            return true;
        }));
    }
}
ModuleAvailableGuard.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ModuleAvailableGuard_Factory() { return new ModuleAvailableGuard(i0.ɵɵinject(i1.ModuleService), i0.ɵɵinject(i2.Router)); }, token: ModuleAvailableGuard, providedIn: "root" });
